// import moment from 'moment';

// import { HomeSelector } from 'selectors';
import { createSlice } from '@reduxjs/toolkit';

// const { getGreetingsText, getImagesName, getMotivationalText } = HomeSelector;

const initialState = {
  initialCache: false,
  greetings: {
    date: null,
    imageIndex: 0,
    greetingTextIndex: 0,
    motivationTextIndex: 0
  }
};

export const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    setInitialCache: (state, action) => {
      state.initialCache = action.payload;
    },
    setGreetings: (state, action) => {
      const { data } = action.payload;

      state.greetings = {
        ...data
      };
    }
  }
});

const homeReducer = homeSlice?.reducer;

export const homeActions = homeSlice.actions;
export default homeReducer;
